import React from 'react'
import { H3 } from '../Heading/index'

/**
 * The upgrade to gaia plus component
 * @param {Object} props - The props
 * @param {Map} props.staticText - The static text
 * @returns {JSX.Element} The upgrade to gaia plus component
 */

function GaiaPlusUpgrade (props) {
  const {
    staticText,
  } = props

  return (
    <div className="gaia-plus-page__upgrade">
      <div className="gaia-plus-page__upgrade-container">
        <H3>{staticText.get('upgradetoGaiaPlus')}</H3>
        { /* TODO */ }
        <div className="gaia-plus-page__upgrade-content"></div>
      </div>
    </div>
  )
}

export default GaiaPlusUpgrade
